import React, { memo } from 'react'

import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

const formatTime = (seconds: number) => {
    const format = (val: number) => `0${Math.floor(val)}`.slice(-2)

    const hours = seconds / 3600
    const minutes = (seconds % 3600) / 60
    const secs = seconds % 60

    return [...(hours >= 1 ? [hours] : []), minutes, secs].map(format).join(':')
}

export type TimeProps = {
    /**
     * current video time
     */
    currentTime: number
    /**
     * the whole video duration
     */
    duration: number
}

export const Time = memo(({ currentTime, duration }: TimeProps) => {
    return (
        <Box minWidth="100px" style={{
            whiteSpace: 'nowrap'
        }}>
            <Typography>
                {formatTime(currentTime)} / {formatTime(duration || 0)}
            </Typography>
        </Box>
    )
})
